import { useTranslations } from '@vocab/react';
import {
  Column,
  Columns,
  List,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';

import translations from '../../locales.vocab';
import { IconStripeNotLoaded } from '../Icons';

const StripeNotLoadedError = () => {
  const { t } = useTranslations(translations);

  return (
    <Columns space="xxsmall" collapseBelow="tablet" reverse>
      <Column width="content">
        <IconStripeNotLoaded />
      </Column>
      <Column width="2/3">
        <Stack space="large">
          <Text weight="strong" size="large">
            {t('stripe.not.loaded.title')}
          </Text>
          <List type="number" tone="secondary" space="small">
            <Text>{t('stripe.not.loaded.step.1')}</Text>
            <Text>{t('stripe.not.loaded.step.2')}</Text>
            <Text>
              {t('stripe.not.loaded.step.3', {
                Content: (children) => children,
                Link: (children) => (
                  <TextLink href="/contactus" target="_blank">
                    {children}
                  </TextLink>
                ),
              })}
            </Text>
          </List>
        </Stack>
      </Column>
    </Columns>
  );
};

export default StripeNotLoadedError;
